import axios from "axios";
import { toast } from "react-toastify";
import { GET_TNC_INFO, TNC_INFO_ERROR } from "../types";

export const gettncData = (e) => async (dispatch) => {
  try {
    var data = new FormData();
    var config = {
      method: "get",
      headers: {},
      url: `${process.env.NEXT_PUBLIC_API_URL}/view-page?page=terms_conditions`,
      data: data,
    };
    const res = await axios(config);
    if (res.data.success) {
      dispatch({
        type: GET_TNC_INFO,
        payload: res.data,
      });
    }
  } catch (error) {
    toast.error(error.response, {
      onClose: () => location.reload(),
    });
    dispatch({
      type: TNC_INFO_ERROR,
      payload: error.response,
    });
  }
};
